import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Fonts } from 'helpers/Consts'
import { IPlace } from "types/Place";

type Props = {
    place: IPlace | undefined;
}

function ClosedCard({ place }: Props) {
  const now = new Date();
  const thisDayOfTheWeek = now.getDay();
  const thisHour = now.getHours();

  const opensIn = () => {
    const placeInfo = place?.data;

    if(!placeInfo) return ''

    const placesWeekdays = [];
    placesWeekdays[0] = placeInfo.sunday_has_delivery ? {dia: 'Domingo', horario: placeInfo.sunday_delivery_time_from} : null;
    placesWeekdays[1] = placeInfo.monday_has_delivery ? {dia: 'Segunda-Feira', horario:  placeInfo.monday_delivery_time_from } : null;
    placesWeekdays[2] = placeInfo.tuesday_has_delivery ? {dia: ' Terça-Feira', horario:  placeInfo.tuesday_delivery_time_from } : null;
    placesWeekdays[3] = placeInfo.wednesday_has_delivery ? {dia: 'Quarta-Feira', horario:  placeInfo.wednesday_delivery_time_from } : null;
    placesWeekdays[4] = placeInfo.thursday_has_delivery ? {dia: 'Quinta-Feira', horario:  placeInfo.thursday_delivery_time_from } : null;
    placesWeekdays[5] = placeInfo.friday_has_delivery ? {dia: 'Sexta-Feira', horario:  placeInfo.friday_delivery_time_from } : null;
    placesWeekdays[6] = placeInfo.saturday_has_delivery ? {dia: 'Sábado', horario:  placeInfo.saturday_delivery_time_from } : null;

    const fromToday = placesWeekdays[thisDayOfTheWeek];

    // se hoje abre, mas agora é antes do horário de abertura
    if(fromToday){
      if(thisHour < parseInt(fromToday.horario.split(':')[0])){
        return `Abre hoje às ${fromToday.horario}`;
      }
    }

    // se não abre hoje, ou se abre hoje mas já passou do horário de abertura
    // vamos procurar apenas nos próximos 7 dias a partir de amanhã
    for(let i = thisDayOfTheWeek + 1; i < thisDayOfTheWeek + 7; i++){
      const place = placesWeekdays[i % 7];
      if(place){
        const isSameDay = i === thisDayOfTheWeek;

        // aqui, pode tanto ser que estamos depois do horário de abertura,
        // ou estamos dentro do horário de abertura porém a loja forçou fechamento antes do horário etc
        if(isSameDay/* && thisHour >= parseInt(place.horario.split(':')[0])*/){
          return `Abre ${place.dia} às ${place.horario}`;
        }
        if(!isSameDay){
          return `Abre ${place.dia} às ${place.horario}`;
        }

      }
    }

    // se chegou até aqui, não encontrou nenhum dia com informações de abertura:
    return ''
  }



    return (
        <Box
            sx={{
                position: 'absolute',
                borderRadius: '7px',
                bottom: 0,
                left: 0,
                height: '100%',
                width: '100%',
                bgcolor: 'rgba(0, 0, 0, 0.70)',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box alignContent='center'>
                <Typography fontFamily={Fonts.fontStyleBoldIt} sx={{ fontSize: { xs: '15px', sm: '20px', md: '22px' } }} >{place?.data.name} está fechado</Typography>
                <Typography fontFamily={Fonts.fontStyleBoldIt} sx={{ fontSize: { xs: '12px', sm: '14px', md: '16px' } }}>{opensIn()}</Typography>
            </Box>
        </Box >
    )
}

export default ClosedCard;